<template>
    <v-dialog v-model="conversationDialog" max-width="1600">
        <template v-slot:activator="{ on }">
            <v-btn color="black" dark v-on="on">Conversation</v-btn>
        </template>
        <v-card style="height:500px">
            <v-layout row wrap fill-height>
                <v-flex d-flex md1>
                    <v-card color="white">
                        <v-card-title primary class="title">Scenes</v-card-title>
                        <v-layout justify-center text-align column>
                            <v-flex v-for="(scene, index) in scenes" :key="index">
                                <v-btn @click="selectScene(scene)">{{ scene.title }}</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex style="margin-left:21px;width:600px">
                    <v-flex style="height:65%">
                        <v-flex offset-lg4 style="width:250px; height:50px">
                            <v-card-title class="headline">SCRIPT-SCENE #</v-card-title>
                        </v-flex>  
                        <v-card color="white" style="height:75%;">                                              
                            <chat-area 
                              :nodeId="nodeId"
                              :storyID="storyID"
                              >
                            </chat-area>                            
                        </v-card>
                    </v-flex>
                    <v-flex style="top:100px; height:20%;">
                        <bottom-block
                          :editor="editor"
                          :timelineContent="timelineContent"
                          :timelineId="timelineId"
                        >
                        </bottom-block>
                    </v-flex>
                    <v-flex  style="margin-top:10px;width:150px;height:15%">
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <!-- <v-btn color="white darken-1" text @click="closeDialog">Close</v-btn> -->
                            <!-- <v-btn color="green darken-1" text @click="closeDialog">Save</v-btn> -->
                        </v-card-actions>
                    </v-flex>                        
                </v-flex>
                <v-flex style="margin-left:21px;margin-right:15px; margin-top:50px">
                    <prev-condition 
                      :nodeId="nodeId"
                      :diagramData="diagramData"
                      :timelineContent="timelineContent"
                    >
                    </prev-condition>
                </v-flex>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
import ChatArea from './chatArea'
import PrevCondition from './prevCondition'
import BottomBlock from './bottomBlock'

export default {
  props: ['diagramData', 'getTimelineById', 'editor', 'storyID'],
  data () {
    return {
      scenes: [],
      conversationDialog: false,
      timelineContent: null,
      timelineId: null,
      nodeId: null
    }
  },
  components: {
    ChatArea,
    PrevCondition,
    BottomBlock
  },
  mounted () {
  },
  watch: {
    conversationDialog () {
      if (this.conversationDialog === true) {
        this.$emit('deSelectTheNode')
        this.fetchScenes()
      }
    }
  },
  methods: {
    closeDialog () {
      this.conversationDialog = false
    },
    fetchScenes () {
      this.scenes = this.diagramData.nodeDataArray.filter(node => node.category === 'Scene')
    },
    selectScene (scene) {
      this.timelineId = scene.timelineId
      this.getTimelineById(this.timelineId)
        .then(timeline => {
          this.timelineContent = timeline
          this.nodeId = timeline.nodeId
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/story-edit-view/conversation/conversation.vue